import React, { useState } from 'react'
import styles from './PeriodPicker.module.scss'
import { LabeledInput, DateRangePicker } from '..'
import { icons } from 'assets'
import { getFormattedDateRange } from './utils'
import { PeriodPickerProps } from './PeriodPicker.types'
import cl from 'classnames'
import { ChangeMarkPoint } from 'components/shared'

const PeriodPicker = (props: PeriodPickerProps) => {
  const {
    size = 'normal',
    label = 'Period',
    placeholder = 'Pick start and end date',
    period,
    setPeriod,
    className,
    noIcon,
    dateFormat,
    versionChange
  } = props

  const [showDatePicker, setShowDatePicker] = useState(false)

  const handleShowDatePicker = (v?: boolean) => {
    if (typeof v !== 'boolean') {
      v = !showDatePicker
    }
    setShowDatePicker(v)
  }

  return (
    <div
      className={cl(styles[size], {
        [styles.positionRelative]: versionChange
      }, className)}
    >
      <LabeledInput
        size={size}
        label={label}
        placeholder={placeholder}
        onClick={handleShowDatePicker}
        icon={noIcon ? undefined : icons.calendar}
        value={getFormattedDateRange(period, dateFormat)}
        keysToHandle={['Backspace']}
        onKeyDown={() => setPeriod(null)}
        className={cl({
          [styles.markedRed]: versionChange
        })}
        previousValue={versionChange?.valueBeforeChange}
      />

      {versionChange && (
        <ChangeMarkPoint
          plateStyleProps={{
            style: { minWidth: 370, marginTop: 40 }
          }}
          style={{ bottom: 50 }}
          {...versionChange}
        />
      )}

      <DateRangePicker
        visible={showDatePicker}
        setVisibility={handleShowDatePicker}
        initialValue={period}
        onSelect={setPeriod}
      />
    </div>
  )
}

export { PeriodPicker }
